import React, { useContext, useMemo } from 'react';
import { ResourcesContext } from '../providers/ResourcesProvider';
import ResourceTable from '../components/ResourceTable';
import { ResourceType } from '../providers/types/Resource';
import ResourceDetail from './ResourceDetail';
import { AuthenticationContext } from '../providers/AuthenticationProvider';
import { ProjectContext } from '../providers/ProjectProvider';

export interface Props {
  childId?: string;
  parentId?: string;
  teamId?: number;
}

export interface ContentInfo {
  guid?: string;
  name?: string;
  type?: ResourceType;
}

const Resources: React.FC<Props> = (props) => {
  const { token } = useContext(AuthenticationContext);
  const { resources } = useContext(ResourcesContext);
  const { projectData } = useContext(ProjectContext);

  const parent = resources.find((r) => r.localId === props.parentId);

  const child = resources.find((r) => r.localId === props.childId);

  const filterResources = () => {
    if (parent) {
      return resources.filter((r) => r.parentGuid === parent.guid);
    } else {
      // Only show top-level resources
      return resources.filter((r) => !r.parentGuid);
    }
  };

  // We can only delete top-level resources if all of their
  // children are available, so let's check for that here.
  const resourcesWithAvailableChildren = useMemo(() => {
    let available: string[] = [];

    resources.forEach((r) => {
      if (r.status === 'available') {
        if (r.parentGuid) {
          available.push(r.guid)
        } else {
          const children = resources.filter((c) => c.parentGuid === r.guid)
          if (children.filter((c) => c.status !== 'available').length === 0) {
            available.push(r.guid)
          }
        }
      }
    })

    return available;
  }, [resources])

  if (child) {
    return <ResourceDetail resourceId={child.localId} />;
  } else if (parent) {
    if (parent.resourceType === 'teidoc') {
      return (
        <ResourceTable
          linkableLocalIds
          projectId={projectData?.projectId}
          resources={resources.filter((r) => r.parentGuid === parent.guid)}
          token={token}
        />
      );
    } else {
      return <ResourceDetail resourceId={parent.localId} />;
    }
  } else {
    return (
      <>
        <ResourceTable
          deletableResources={resourcesWithAvailableChildren}
          linkableLocalIds
          projectId={projectData?.projectId}
          resources={filterResources()}
          token={token}
        />
      </>
    );
  }
};

export default Resources;
